import { useEffect, useState, useCallback } from "react";
import { api, fmtINR } from "../../lib/api";
import { PageHeader } from "../../components/Layout";
import {
  Table, TableBody, TableCell, TableHead, TableHeader, TableRow,
} from "../../components/ui/table";

export default function PartnerRatecards() {
  const [rows, setRows] = useState([]);
  useEffect(() => { api.get("/partner/ratecards").then((r) => setRows(r.data)); }, []);
  return (
    <>
      <PageHeader title="Ratecards" subtitle="Standard pricing (read-only)" />
      <div className="p-8">
        <div className="border border-border rounded-sm bg-card overflow-hidden">
          <Table>
            <TableHeader>
              <TableRow className="bg-secondary/50">
                <TableHead>Product Category</TableHead><TableHead>Product Type</TableHead>
                <TableHead>Service Type</TableHead><TableHead>Part Name</TableHead>
                <TableHead className="text-right">Amount</TableHead>
              </TableRow>
            </TableHeader>
            <TableBody data-testid="partner-ratecards-table">
              {rows.length === 0 && <TableRow><TableCell colSpan={5} className="text-center py-10 text-muted-foreground">No ratecards</TableCell></TableRow>}
              {rows.map((r) => (
                <TableRow key={r.id} className="hover:bg-secondary/30">
                  <TableCell className="font-semibold">{r.product_category}</TableCell>
                  <TableCell>{r.product_type}</TableCell>
                  <TableCell><span className="text-xs font-semibold uppercase tracking-wide bg-secondary px-2 py-1 rounded-sm">{r.service_type}</span></TableCell>
                  <TableCell className="text-muted-foreground">{r.part_name || "—"}</TableCell>
                  <TableCell className="text-right font-mono font-semibold">{fmtINR(r.amount)}</TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </div>
      </div>
    </>
  );
}
